// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

type TeamArtifactTTLChangeSummaryProps = {
  durationOld: string | undefined;
  durationNew: string | undefined;
  adminOnlyEditTTLOld: string | undefined;
  adminOnlyEditTTLNew: string | undefined;
};

export const TeamArtifactTTLChangeSummary = ({
  durationOld,
  durationNew,
  adminOnlyEditTTLOld,
  adminOnlyEditTTLNew,
}: TeamArtifactTTLChangeSummaryProps) => {
  return (
    <Tailwind style={{width: '100%'}}>
      <div className="min-h-130 mt-16 flex flex-row gap-8">
        <div className="mr-8 w-4 rounded bg-teal-450" />
        <div className="flex w-full flex-col gap-8">
          {durationOld !== durationNew ? (
            <div className="border-1 m-h-65 flex w-full flex-row rounded border border-solid border-moon-250 px-12 py-8">
              <div className="mr-8 self-center p-10">
                <Icon name="recent-clock" />
              </div>
              <div className="flex-col">
                <div className="text-base font-semibold text-moon-450">
                  Default TTL Duration
                </div>
                <div className="text-base font-normal">
                  Changed from '{durationOld}' to '{durationNew}'
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
          {adminOnlyEditTTLOld !== adminOnlyEditTTLNew ? (
            <div className="border-1 m-h-65 flex w-full flex-row rounded border border-solid border-moon-250 px-12 py-8">
              <div className="mr-8 self-center p-10">
                <Icon name="admin-shield-safe" />
              </div>
              <div className="flex-col">
                <div className="text-base font-semibold text-moon-450">
                  TTL Permissions
                </div>
                <div className="text-base font-normal">
                  Changed from '{adminOnlyEditTTLOld}' to '{adminOnlyEditTTLNew}
                  '
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </Tailwind>
  );
};
